import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=020700d8&"
import script from "./BaseRadio.vue?vue&type=script&lang=js&"
export * from "./BaseRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports